<template>
    <div class="xc-page xc-page-sandwich">
        <!-- <div class="guide" :style="{right: '-' + guidePageWidth}">
            <div class="open-guide" @click="controlGuide">
                <img src="/img/home/open.png" alt v-if="showSwitch">
                <img src="/img/home/hide.png" alt v-else>
            </div>
            <div class="guide-content" ref="element">
                <img src="/img/home/content.jpg" alt>
            </div>
        </div>
        <div class="guide-bg" v-if="!showSwitch" @click="controlGuide"></div> -->
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <a>节目管理</a>
                <a href>节目列表</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form">
                            <div class="xc-form-inline ele-float">
                                <xc-form-item label="节目名称:">
                                    <input type="text" placeholder="请输入节目名称" class="xc-input" name="programName" v-model="mix_query.programName" />
                                </xc-form-item>
                                <xc-form-item label="节目状态:">
                                    <select class="xc-select" name="programStatus" v-model="mix_query.programStatus">
                                        <option value>全部</option>
                                        <option :value="item.value" :key="index" v-for="(item, index) in globalConfig.programStatus">
                                            {{ item.desc }}
                                        </option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item label="品牌名称:">
                                    <select name="programOrigin" class="xc-select" v-model="mix_query.brandId">
                                        <option value>请选择</option>
                                        <option :value="item.brandId" :key="index" v-for="(item, index) in brandList">
                                            {{ item.brandName }}
                                        </option>
                                    </select>
                                </xc-form-item>
                                <!-- <xc-form-item label="节目来源:">
                                    <select name="programOrigin" class="xc-select" v-model="mix_query.programOrigin">
                                        <option value>全部</option>
                                        <option :value="item.value" :key="index" v-for="(item, index) in globalConfig.programOrigin">
                                            {{ item.desc }}
                                        </option>
                                    </select>
                                </xc-form-item> -->
                                <xc-form-item label="投放门店:">
                                    <select name="putDistrict" class="xc-select" v-model="mix_query.deviceGroupId">
                                        <option value>全部</option>
                                        <option :value="item.deviceGroupId" :key="index" v-for="(item, index) in globalConfig.deviceGroup">
                                            {{ item.groupName }}
                                        </option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button class="xc-btn xc-btn-primary" type="submit" @click.prevent="mix_search">查询</button>
                                    <!-- <router-link class="xc-btn xc-btn-default" :to="$config.adminPath + '/program/add'">添加节目</router-link> -->
                                    <a class="xc-btn xc-btn-default" @click="addProgramma">添加节目</a>
                                </div>
                            </div>
                            <!-- <div class="xc-form-inline">
                                <xc-form-item label="终端类型:">
                                    <select name="deviceType" class="xc-select">
                                        <option value="">不限</option>
                                        <option value="0">横屏</option>
                                        <option value="1">竖屏</option>
                                    </select>
                                </xc-form-item>
                            </div> -->
                            <div class="null-box"></div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>节目ID</th>
                                    <th>品牌名称</th>
                                    <!-- <th>节目来源</th> -->
                                    <th style="width:300px;">节目名称(时长)</th>
                                    <th>节目素材数</th>
                                    <th>状态</th>
                                    <th>投放时间</th>
                                    <th>排序</th>
                                    <th>备注</th>
                                    <th>投放设备</th>
                                    <!-- <th>监播数据</th> -->
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr v-for="(item, index) in list" :class="className | setClass(item, onlineRemindDay, offlineRemindDay)" :key="index">
                                        <td>
                                            {{ item.programId }}
                                        </td>
                                        <!-- <td>{{item.deviceType}}</td> -->
                                        <td>{{item.brandName}}</td>
                                        <!-- <td>
                                            {{ item.originName }}
                                        </td> -->
                                        <td class="xc-link">
                                            <a @click="action('preview', item, $event)">
                                                {{ item.programName + "(" + item.programDuration/1000 +"s)" }}
                                            </a>
                                        </td>
                                        <td>
                                            {{ item.sourceNum }}
                                        </td>
                                        <td>
                                            {{ item.programStatus }}
                                        </td>
                                        <td>
                                            <p>
                                                {{ item.putinStartTime }}
                                            </p>
                                            <p>
                                                {{ item.putinEndTime }}
                                            </p>
                                        </td>
                                        <!-- <td>
                                            {{item.addUserName}}
                                        </td>
                                        <td>
                                            {{item.addTime}}
                                        </td>
                                        <td>
                                            {{item.updateTime}}
                                        </td> -->
                                        <td class="remark" >
                                            <span class="setRank" @click='setRankBut(item)'>{{ item.rank? item.rank:'设置排序'}}</span>
                                        </td>
                                        <td class="remark" :title="item.rejectReson">
                                            {{ item.rejectReson }}
                                        </td>
                                        <td class="xc-link">
                                            <div v-if="item.deviceNum">
                                                <a @click="action('watchPoint', item, $event)">查看</a>
                                            </div>
                                            <div v-else-if="item.programStatus == '待发布'">
                                                <a @click="action('selectPoint', item, $event)">去选点</a>
                                            </div>
                                        </td>
                                        <!-- <td class="xc-link">
                                            <template v-if="item.programStatus == '播放中' || item.programStatus == '已过期'">
                                                <a @click="action('watchDetail', item, $event)">查看</a>
                                            </template>
                                        </td> -->
                                        <td>
                                            <xc-btn-select title="管理">
                                                <xc-btn-select-item title="预览" @click.native="action('preview', item, $event)" />
                                                <xc-btn-select-item title="下发详情" @click.native="action('pushDetail', item, $event)" v-if="item.programStatus == '待播放' || item.programStatus == '播放中' || item.programStatus == '已过期'" />
                                                <xc-btn-select-item title="下载详情" @click.native="action('downloadDetail', item, $event)" v-if="item.deviceDownloadCount" />
                                                <xc-btn-select-item title="编辑" v-if="item.programStatus != '已过期'" @click.native="action('edit', item, $event)" />
                                                <xc-btn-select-item title="发布" v-if="item.programStatus == '待发布'" @click.native="action('selectPoint', item, $event)" />
                                                <xc-btn-select-item title="复制" @click.native="action('copyProgram', item, $event)" />
                                                <!-- <xc-btn-select-item v-if="item.programStatus == '待审核'" title="审核" @click.native="action('check',item,$event)" />-->
                                                <xc-btn-select-item title="操作日志" @click.native="action('log', item, $event)" />
                                                <xc-btn-select-item title="删除" @click.native="action('delete', item, $event)" v-if="item.programStatus != '播放中'" />
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="20" class="xc-s-tac">暂无数据</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 点击删除时的弹窗 -->
        <div class="xc-modal xc-modal-dialog" v-if="modalName == 'remoteShutdown'">
            <div class="xc-modal-mask" @click="modalName = null"></div>
            <div class="xc-modal-wrap xc-anim-scaleIn">
                <div class="xc-modal-content">
                    <div class="xc-modal-header">
                        <div class="xc-modal-title">删除提示</div>
                        <div class="xc-modal-close" @click="modalName = null"></div>
                    </div>
                    <div class="xc-modal-body xc-flex-center">
                        <div class="xc-device-tipText">"是否删除该节目"</div>
                    </div>
                    <div class="xc-modal-footer xc-flex-center">
                        <div class="xc-btn-group">
                            <div class="xc-btn xc-btn-default" @click="modalName = null">取消</div>
                            <div class="xc-btn xc-btn-primary" @click="deleteProgram">确定</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 设置排序 -->
        <div class="xc-modal xc-modal-dialog" v-if="modalName == 'rankShow'">
            <div class="xc-modal-mask" @click="modalName = null"></div>
            <div class="xc-modal-wrap xc-anim-scaleIn">
                <div class="xc-modal-content">
                    <div class="xc-modal-header">
                        <div class="xc-modal-title">设置播放排序</div>
                    </div>
                    <div class="xc-modal-body xc-flex-center">
                        <li class="search-list">
                            <span>播放顺序：</span>
                            <input type="text" class="xc-input " v-model="rank" >
                        </li>
                    </div>
                    <div class="xc-modal-footer xc-flex-center">
                        <div class="xc-btn-group">
                            <div class="xc-btn xc-btn-default" @click="modalName = null">取消</div>
                            <div class="xc-btn xc-btn-primary" @click="sureRank">确定</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分页 -->
        <div class="xc-page-footer">
            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
        </div>
    </div>
</template>

<script>
import listMixin from "../xc-ui/mixins/list";
import myLayerImport from "@/libs/myLayer";
import programApi from "../api/program";
import globalConfigApi from "../api/global-config";
import moment from 'moment';
import { setTimeout } from "timers";

export default {
    name: "programList",
    mixins: [listMixin],
    data() {
        return {
            // 列表key
            mix_listKey: "list",

            // 列表唯一字段
            mix_listId: "programVersion",

            // 默认查询参数
            mix_query: {
                deviceGroupId: "",
                programStatus: "",
                // programOrigin: "",
                brandId: "",
                programName: ""
            },
            // 排名
            rank:'',
            // 单条信息
            itemInf:{},
            // 列表数据
            list: [],

            // 模态框
            modalName: null,
            modal: {},

            // 全局配置
            globalConfig: {
                programStatus: []
            },

            programVersion: "",

            // 品牌列表
            brandList:[],

            // 获取节目的上线提醒和到期提醒的数据
            onlineRemindDay: 0,
            offlineRemindDay: 0,
            
            // 节目上下线提醒是需要的展示的class
            className:"",
        }
    },
    created() {
        this.mix_query.brandId = this.$route.query.brandId || "";
        this.$http.get("/getAlarmConfig").then(res => {
            this.onlineRemindDay = res.data.programOnlineAlarm.value;
            this.offlineRemindDay = res.data.programOfflineAlarm.value;
        })
    },
    async mounted() {
        await myLayerImport();
        // 动态计算元素宽度
        // this.$nextTick(() => {
        //     let guidePageWidth = window.getComputedStyle(this.$refs.element).width;
        //     if (guidePageWidth) {
        //         this.guidePageWidth = guidePageWidth;
        //         this.guidePageWidthCope = guidePageWidth;
        //     }
        // })
    },
    methods: {
        // 设置排序
        setRankBut(item){
            console.log(item)
            this.itemInf=JSON.parse(JSON.stringify(item))
            this.rank=this.itemInf.rank
            this.modalName = "rankShow";
           
        },
        // 确定排序
        sureRank(){
             var params={
                programVersion:this.itemInf.programVersion,
                rank:this.rank
            }
            this.$http.post("/program/updateProgramRank", params).then(res => {
                    this.$message.success(res.msg);
                    this.modalName=null
                    this.initData();
                })
        },
        // 添加节目
        addProgramma() {
            layer.openSubpage(this.$config.adminPath + '/program/add');
            // 弹窗中使用
            window.initData = this.initData;
        },

        // 操作引导页
        controlGuide() {
            this.showSwitch = !this.showSwitch;
            if (this.showSwitch) {
                this.guidePageWidth = this.guidePageWidthCope;
            } else {
                this.guidePageWidth = "0px";
            }
        },

        // 删除节目
        deleteProgram() {
            let that = this;
            programApi.deleteProgram(this.programVersion).then(v => {
                that.initData();
                that.$message.success("删除成功");
                this.modalName = "";
            })
        },
        // 初始化数据
        initData(ready) {
            if (ready) {
                globalConfigApi().then(v => {
                    this.globalConfig.programStatus = v.data.programStatus;
                    this.globalConfig.programOrigin = v.data.programOrigin;
                });

                programApi.getDeviceGroupSelect().then(v => {
                    this.globalConfig.deviceGroup = v.data;
                });
            }

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };

            programApi.programList(search, {showLoading: true}).then(ret => {
                // 添加mix_checkbox属性
                // this.list = this.mix_format(ret.data.list);
                this.list = ret.data.list;
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            });

            this.$http.get("/brand/listAllBrands").then(res => {
                this.brandList = res.data;
            })
        },

        // 操作单条数据
        action(...args) {
            const [action, item, index] = args;
            const e = args[args.length - 1];

            switch (action) {
                case "preview":
                    layer.openSubpage(this.$config.adminPath + "/program/" + item.programVersion + "/preview");
                    break;
                case "edit":
                    // 如果是节目待播放、播放中编辑需要提示下线
                    if (item.programStatus == "待播放" || item.programStatus == "播放中") {
                        this.$xc.confirm({
                            title: "温馨提示",
                            msg: "节目已下发，确定将已发节目下线进行重新编辑？重新编辑后已下发节目的历史操作数据将清空。"
                        }).then(v => {
                            return programApi.offlineProgram(item.programVersion);
                        }).then(v => {
                            // this.$router.push(
                            //   this.$config.adminPath + "/program/" + item.programVersion
                            // );
                            layer.openSubpage(this.$config.adminPath + "/program/" + item.programVersion);

                            // 弹窗中使用
                            window.initData = this.initData;
                        });
                    } else {
                        // this.$router.push(
                        //   this.$config.adminPath + "/program/" + item.programVersion
												// );
                        layer.openSubpage(this.$config.adminPath + "/program/" + item.programVersion);

                        // 弹窗中使用
                        window.initData = this.initData;
                    }
                    break;
                case "check":
                    let backUrl = this.$route.fullPath;
                    this.$router.push(this.$config.adminPath + "/program/" + item.programVersion + "/check?backUrl=" + backUrl);
                    break;
                case "log":
                    this.layer({
                        area: ["977px", "609px"],
                        content: this.$config.adminPath + "/program/" + item.programVersion + "/log"
                    });
                    break;
                case "copyProgram":
                    programApi.copyProgram(item.programVersion).then(v => {
                        this.initData();
                    });
                    break;
                case "watchPoint":
                    this.layer({
                        area: ["977px", "609px"],
                        content: `${this.$config.adminPath}/program/${item.programVersion}/put-district-list`
                    });
                    break;
                case "selectPoint":
                    // 选点前验证节目是否完整
                    programApi.checkSource({ programVersion: item.programVersion }).then(v => {
                        if (v.data) {
                            // this.$router.push(
                            //   `${this.$config.adminPath}/program/${item.programVersion}/select-point`
                            // );
                            layer.openSubpage(this.$config.adminPath + "/program/" + item.programVersion + "/select-point");
                        } else {
                            this.$xc.confirm({msg: "节目内容不完整，请补全节目内容"}).then(v => {
                                // this.$router.push(
                                //   `${this.$config.adminPath}/program/${item.programVersion}`
                                // );
                                layer.openSubpage(this.$config.adminPath + "/program/" + item.programVersion);
                            });
                        }
                    });
                    break;
                // 查看监播
                case "watchDetail":
                    this.layer({
                        area: ["977px", "609px"],
                        content: `${this.$config.adminPath}/program/${item.programVersion}/report?programName=${item.programName}`
                    });
                    break;
                // 下载详情
                case "pushDetail":
                    this.layer({
                        area: ["1010px", "609px"],
                        content: `${this.$config.adminPath}/program/${item.programVersion}/push`
                    });
                    break;
                // 下载详情
                case "downloadDetail":
                    this.layer({
                        area: ["1010px", "609px"],
                        content: `${this.$config.adminPath}/program/${item.programVersion}/download`
                    });
                    break;
                case "delete":
                    this.modalName = "remoteShutdown";
                    this.programVersion = item.programVersion;
                    break;
                default: break;
            }
        },
        layer(options) {
            layer.open({
                type: 2,
                title: false,
                closeBtn: 0,
                shadeClose: true,
                area: ["672px", "379px"],
                ...options
            });
        },
    },
    filters:{
        setClass(value, data, onlineRemindDay, offlineRemindDay){
            // console.log(value, "value", data, this, onlineRemindDay, offlineRemindDay);
            let shangXian = moment(data.putinStartTime).diff(moment(), "days", true);
            let xiaXian = moment(data.putinEndTime).diff(moment(), "days", true);
            if(shangXian > 0 && shangXian < onlineRemindDay){
                return "online-remind";
            }else if(xiaXian > 0 && xiaXian < offlineRemindDay){
                return "offline-remind";
            }
        }
    }
}
</script>

<style scoped lang="scss">
.remark {
    max-width: 10em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.guide {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    height: 100%;
    z-index: 999;
    width: auto;
    transition: right 0.3s ease;
    -webkit-transition: right 0.3s ease; /* Safari */
    .guide-content {
        height: 100%;
        img {
            height: 100%;
        }
    }
}

.guide-bg {
    background: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    right: 0;
    top: 0;
    height: 100%;
    z-index: 998;
    width: 100%;
}

.null-box {
    clear: both;
}

// 上线提醒和下线提醒
.online-remind{
    background-color: #70B603;
    color: #fff;
    &:hover{
        background-color: #70B603;
    }
    .xc-link a{
        color:#fff;
    }
}
.offline-remind{
    background-color: #D9001B;
    color: #fff;
    &:hover{
        background-color: #D9001B;
    }
    .xc-link a{
        color:#fff;
    }
}
/* 设置排序 */
.setRank{
    color: #4a80f7;
    cursor: pointer;
}
</style>
